<template>
  <div class="public-design-dialog-box-container">
    <div class="public-design-dialog-box">
      <div class="public-design-dialog">
        <span class="close-dialog" @click="closeDialog(true)">X</span>
        <form-design ref="formDesign" v-if="designDialog.type==='form'" :id="designDialog.id" @closeForm="closeDialog" :formValue="formValue"></form-design>
        <process-design v-if="designDialog.type==='process'" :id="designDialog.id" @closeForm="closeDialog"></process-design>
        <report-design ref="reportDesign" v-if="designDialog.type==='report'"
                       :id="designDialog.id"
                       :dataSourceReport="designDialog.dataSourceReport"
                       :selectPlate="designDialog.selectPlate"
                       :designDialog="designDialog"
                       @closeReport="closeDialog"
                       :reportValue="reportValue"
         @changeSelectPlate="changeSelectPlate"></report-design>
        <outside-chain-design ref="outsideChainDesign" v-if="designDialog.type==='outsideChain'" :id="designDialog.id" @closeForm="closeDialog" :formValue="formValue"></outside-chain-design>
      </div>
      <div class="modal" v-show="designDialog.visiable"></div>
      <el-dialog class="report-has-attr-change-dialog" :visible.sync="hasAttrChange" center :top="'0'" :close-on-click-modal="false" :close-on-press-escape="false">
        <span>{{ title }}</span>
        <div slot="footer" class="dialog-footer">
          <el-button @click="buttonClick(1)">不保存</el-button>
          <el-button @click="buttonClick(2)">取消</el-button>
          <el-button type="primary" @click="buttonClick(3)">保存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import FormDesign from '@/components/form/design/form-design.vue'
import ProcessDesign from '@/components/process/design/process-design.vue'
import ReportDesign from '@/components/report/design/report-design.vue'
import OutsideChainDesign from '@/components/form/design/outside-chain-design.vue'
export default {
  name: 'designDialog',
  props: ['designDialog', 'newReport', 'oldReport'],
  data () {
    return {
      reportValue: {
        oldValue: '',
        newValue: ''
      },
      formValue: {
        oldValue: '',
        newValue: ''
      },
      hasAttrChange: false,
      title: '是否保存此报表的更改？'
    }
  },
  components: {
    FormDesign,
    ProcessDesign,
    ReportDesign,
    OutsideChainDesign
  },

  methods: {
    closeDialog () {
      let type = this.designDialog.type
      let result = false
      if (type === 'report') {
        result = this.reportValue.oldValue && this.reportValue.newValue && this.reportValue.oldValue !== JSON.stringify(this.reportValue.newValue)
        this.title = '是否保存此报表的更改？'
      } else if (type === 'form') {
        result = this.formValue.oldValue && this.formValue.newValue && this.formValue.oldValue !== JSON.stringify(this.formValue.newValue)
        this.title = '是否保存此表单的更改？'
      }
      if (result) {
        this.hasAttrChange = true
      } else {
        this.buttonClick(1)
      }
    },
    // 1：不保存   2：取消   3：保存
    buttonClick (type) {
      if (type === 1) {
        this.designDialog.visiable = false
        this.$emit('closeForm', type)
      } else if (type === 3) {
        if (this.designDialog.type === 'report') {
          this.$refs.reportDesign && this.$refs.reportDesign.saveAndClose()
        } else if (this.designDialog.type === 'form') {
          this.$refs.formDesign && this.$refs.formDesign.save(true)
        }
      }
      if (this.hasAttrChange) {
        this.hasAttrChange = false
      }
    },
    changeSelectPlate (selectPlate) {
      this.designDialog.selectPlate = selectPlate
    }
  }
}
</script>
<style lang="scss" >
.public-design-dialog-box-container {
  .public-design-dialog-box {
    .public-design-dialog {
      position: absolute;
      width: 100%;
      left: 0;
      z-index: 4;
      top: 0%;
      height: 100%;
      background: #fff;

      .close-dialog {
        position: absolute;
        right: 2px;
        top: -2px;
        cursor: pointer;
        z-index: 201;
        color: #929191;

        &:hover {
          color: red;
        }
      }
    }

    .modal {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: .5;
      background: #000;
      z-index: 3;
    }

    .report-has-attr-change-dialog {
      .el-dialog {
        width: 400px;
        height: 172px;
        top: 30% !important;
      }
      .el-dialog__header {
        background-color: #fff;
      }
      .el-dialog__body {
        text-align: center;
        height: calc(100% - 80px);
      }
      .el-dialog__footer {
        padding: 0;
        .dialog-footer {
          .el-button {
            width: 82px;
            height: 26px;
            border: 1px solid rgba(84,171,241,1);
            border-radius: 4px;
            padding: 0;
            color: #54ABF1;
          }
          .el-button--default {
            &:hover, &:active, &:focus {
              background-color: #fff;
              color: #54ABF1;
            }
          }
          .el-button--primary {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/public-design-dialog.vue